"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = exports.P = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.H1 = styled_components_1.default.h1 `
  font-size: 1.125rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.greyBase};
  letter-spacing: -0.01rem;
  margin-bottom: ${({ theme }) => theme.spacings.xs};
  p ~ & {
    margin-top: ${({ theme }) => theme.spacings.l};
  }
`;
exports.H2 = styled_components_1.default.h2 `
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.greyBase};
  line-height: 1.5;
  margin-bottom: ${({ theme }) => theme.spacings.xs};
  p ~ & {
    margin-top: ${({ theme }) => theme.spacings.m};
  }
`;
exports.H3 = styled_components_1.default.h3 `
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.greyLighten40};
  letter-spacing: -0.01rem;
  line-height: 1.5;
`;
exports.H4 = styled_components_1.default.h4 `
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.greyBase};
  letter-spacing: -0.01rem;
  line-height: 1.5;
`;
exports.P = styled_components_1.default.p `
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.greyLighten40};
  letter-spacing: -0.01rem;
  line-height: 1.5;
  line-height: normal;
  text-decoration: none;
  margin-bottom: ${({ theme }) => theme.spacings.m};
`;
exports.A = styled_components_1.default.a `
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.greyBase};
  letter-spacing: -0.01em;
  line-height: 1.5;
  line-height: normal;
  text-decoration: none;
`;
//# sourceMappingURL=texts.js.map